// extracted by mini-css-extract-plugin
export default {"ButtonContainer":"SkeuomorphismButton_ButtonContainer__CXiFL","ButtonBefore":"SkeuomorphismButton_ButtonBefore__kVgC0"};